import * as h from '../helpers/helpers';

export function getPNGDimensions(png) {
	let height = 0;
	let width = 0;

	var slice = png.slice(16,20);
	height = slice[0]
	height = (height * 256) + slice[1];
	height = (height * 256) + slice[2];
	height = (height * 256) + slice[3];

	slice = png.slice(20,24);
	width = slice[0]
	width = (width * 256) + slice[1];
	width = (width * 256) + slice[2];
	width = (width * 256) + slice[3];

	return {
		width: width,
		height: height
	}
}

/**
 * Start of frame markers.
 */

var sof = {
  0xc0: true,
  0xc1: true,
  0xc2: true,
  0xc3: true,
  0xc5: true,
  0xc6: true,
  0xc7: true,
  0xc9: true,
  0xca: true,
  0xcb: true,
  0xcd: true,
  0xce: true,
  0xcf: true
};

/**
 * Uint16BE.
 */

function u16(buf, o) {
  return (buf[o] << 8) | buf[o + 1];
}

/**
 * Return dimensions from jpeg `buf`.
 *
 * @param {Buffer} buf
 * @return {Object} or undefined
 * @api public
 */

export function getJPGDimensions(buf) {
  var len = buf.length;
  var o = 0;

  // magick
  var jpeg = (0xff === buf[0]) && (0xd8 === buf[1]);
  if (!jpeg) return;
  o += 2;

  while (o < len) {
    // find next marker
    while (0xff !== buf[o]) o++;

    // skip marker
    while (0xff === buf[o]) o++;

    // non-SOF jump to the next marker
    if (!sof[buf[o]]) {
      o += u16(buf, ++o);
      continue;
    }

    var w = u16(buf, o + 6);
    var h = u16(buf, o + 4);

    return { width: w, height: h };
  }
}

export function CombineImages(images) {
    let combinedImages = [];
    if (images.length === 0) return combinedImages;
    if (images.length === 1) {
        combinedImages.push(images[0]);
        return combinedImages;
    }

    // Sort images by ImageFileLocationIdentifier
    //images.sort((a, b) => a.imageFileLocationIdentifier.localeCompare(b.imageFileLocationIdentifier));

    let previousImage = images[0];
    combinedImages.push(previousImage);

    for (let i = 1; i < images.length; ++i) {
      let currentImage = images[i];
      if (currentImage.imageFileLocationIdentifier === previousImage.imageFileLocationIdentifier) {
          // combine this image with previous
          if (!currentImage.imageSourceCaption.includes(previousImage.imageSourceCaption))
            previousImage.imageSourceCaption = h.addWithSpacer(previousImage.imageSourceCaption, currentImage.imageSourceCaption, " - ");
      } else {
          // current image is not the same as the previous, add to list
          combinedImages.push(currentImage);
          previousImage = currentImage;
      }
    }

    return combinedImages;
}

export function GroupImagesForExhibits(images) {
  let imgList = [];
  let largeImages = [];
  let narrowImages = [];

  let combined = CombineImages(images);
  // separate large images
  combined.forEach(img => {
    let title = img.imageSourceCaption;
    if (!title) title = img.imageCategoryType;

    if (["Graph", "Map", "Boundaries"].some(item => title.includes(item))) {
      // found a large (supposedly) image
      largeImages.push(img);
    } else {
      narrowImages.push(img);
    }
  });

  // collect large images into groups of one
  largeImages.forEach(li => {
    let row1 = [];
    row1.push(li);
    imgList.push(row1);
  })


  // collect narrow images into groups of two
  let imgCount = narrowImages.length;
  let ix = 0;
  while (ix < imgCount) {
    let row1 = [];
    row1.push(narrowImages[ix]);
    ++ix;
    if (ix < imgCount)
      row1.push(narrowImages[ix]);
    else
      row1.push(null);
    ++ix;
    imgList.push(row1);
  }

  return imgList;
}